import { HTMLAudioChannel } from "../media/HTMLAudioChannel";
import { WebAudioChannel } from "../media/WebAudioChannel";
import { AudioDataCache } from "../media/AudioDataCache";
import { Browser } from "../utils/Browser";
import { VideoTexture } from "../media/VideoTexture";
import { HTMLVideoTexture } from "../media/HTMLVideoTexture";
import { ILaya } from "../../ILaya";
import { Event } from "../events/Event";
import { VideoPlayerBackend } from "../media/VideoPlayerBackend";
import { HTMLVideoPlayer } from "../media/HTMLVideoPlayer";
import { PAL } from "./PlatformAdapters";
export class MediaAdapter {
    constructor() {
        this.touchToStart = true;
        this._firstTouch = true;
        this.audioDataCache = new AudioDataCache();
        this.suspendedMedias = new Set();
        this.touchToStart = PAL.g == null;
        this.init();
    }
    init() {
        let ctxClass = window.AudioContext || window["webkitAudioContext"] || window["mozAudioContext"];
        if (ctxClass != null)
            this.audioCtx = new ctxClass();
        this.shortAudioClass = this.audioCtx ? WebAudioChannel : HTMLAudioChannel;
        this.longAudioClass = HTMLAudioChannel;
        this.videoTextureClass = HTMLVideoTexture;
        this.videoPlayerClass = HTMLVideoPlayer;
    }
    createSoundChannel(url, longAudioUsage) {
        return longAudioUsage ? new this.longAudioClass(url) : new this.shortAudioClass(url);
    }
    createVideoTexture() {
        if (this.videoTextureClass == null) {
            PAL.warnIncompatibility("VideoTexture");
            return new VideoTexture();
        }
        else
            return new this.videoTextureClass();
    }
    createVideoPlayer() {
        if (this.videoPlayerClass == null) {
            PAL.warnIncompatibility("VideoPlayer");
            return new VideoPlayerBackend();
        }
        else
            return new this.videoPlayerClass();
    }
    decodeAudioData(data) {
        if (this.audioCtx)
            return this.audioCtx.decodeAudioData(data);
        else
            return Promise.resolve(null);
    }
    resumeUntilGotFocus(media) {
        if (this.suspendedMedias.size === 0) {
            ILaya.stage.on(Event.MOUSE_UP, this, this.onGotFocus);
            if (!this._firstTouch || !this.touchToStart)
                ILaya.stage.on(Event.FOCUS, this, this.onGotFocus);
        }
        this.suspendedMedias.add(media);
        media.pause();
        media._autoResume = true;
    }
    canPlayType(type) {
        if (typeof (HTMLAudioElement) !== "undefined" && typeof (HTMLAudioElement.prototype.canPlayType) === "function") {
            if (!this._testElement)
                this._testElement = Browser.createElement("audio");
            return this._testElement.canPlayType(type);
        }
        else
            return "";
    }
    onGotFocus() {
        this._firstTouch = false;
        ILaya.stage.off(Event.MOUSE_UP, this, this.onGotFocus);
        ILaya.stage.off(Event.FOCUS, this, this.onGotFocus);
        if (this.suspendedMedias.size === 0)
            return;
        let arr = Array.from(this.suspendedMedias).filter(c => c._autoResume);
        this.suspendedMedias.clear();
        this.beforeResumeMedias(arr).then(() => {
            for (let medias of arr) {
                medias._autoResume = false;
                medias.resume();
            }
        });
    }
    beforeResumeMedias(medias) {
        let checkCtx = false;
        for (let channel of medias) {
            if (channel instanceof WebAudioChannel && !checkCtx) {
                checkCtx = true;
                let state = this.audioCtx.state;
                if (state === "suspended" || state === "interrupted") {
                    return this.audioCtx.resume().catch(e => { });
                }
            }
        }
        return Promise.resolve();
    }
}
PAL.register("media", MediaAdapter);
